import * as React from 'react';
import { Box, Button, Flex, Grid, Heading, Image, Link, Text, useDisclosure } from '@chakra-ui/react';
import { DirectusImage } from './directusImage';
import { WarrantyModal, warrantyImage, warrantyTitle, warrantyEuUrl } from './warrantyLabel';
export { warrantyTitle } from './warrantyLabel';

export const WarrantySection: React.FC<{ backgroundImage?: string }> = ({ backgroundImage }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box
      as="section"
      id="gewaehrleistungsrechte"
      aria-labelledby="warranty-section-title"
      lang="de"
      bg="gray.50"
      color="black"
    >
      <Grid maxW="8xl" mx="auto" templateColumns={['minmax(0, 1fr)', null, null, '1fr 1fr']} alignItems="stretch">
        <Flex position="relative" bg="gray.800" p={[8, null, null, 12]} align="center" justify="center">
          {backgroundImage && (
            <Box position="absolute" inset={0} aria-hidden="true">
              <DirectusImage src={backgroundImage} alt="" w="full" h="full" objectFit="cover" />
            </Box>
          )}
          <Box position="absolute" inset={0} bg="blackAlpha.600" />
          <Box
            as="button"
            type="button"
            onClick={onOpen}
            aria-label="Vollständiges Original-Label anzeigen"
            aria-haspopup="dialog"
            position="relative"
            w="full"
            maxW={['240px', null, null, '340px']}
            _focusVisible={{ outline: '3px solid', outlineColor: 'brand', outlineOffset: '6px' }}
          >
            <Image
              src={warrantyImage}
              alt="Vollständiges offizielles deutsches EU-Gewährleistungslabel"
              width={1697}
              height={2400}
              w="100%"
              h="auto"
              loading="lazy"
            />
          </Box>
        </Flex>
        <Flex direction="column" align="flex-start" justify="center" p={[8, null, null, 16]}>
          <Heading
            as="h2"
            id="warranty-section-title"
            size={['xl', null, null, '2xl']}
            lineHeight="short"
            sx={{ hyphens: 'auto' }}
            overflowWrap="anywhere"
            mb={5}
          >
            {warrantyTitle}
          </Heading>
          <Text fontSize={['md', null, null, 'xl']} mb={8}>
            Beim Kauf eines Fahrzeugs gelten die gesetzlichen Gewährleistungsrechte. Alle wichtigen Informationen zu
            Ihren Rechten finden Sie im offiziellen EU-Gewährleistungslabel.
          </Text>
          <Button onClick={onOpen} aria-haspopup="dialog" variant="brandPrimary" mb={5}>
            Original-Label anzeigen
          </Button>
          <Link
            href={warrantyEuUrl}
            textDecoration="underline"
            textUnderlineOffset="3px"
            fontSize="sm"
            overflowWrap="anywhere"
            py={2}
          >
            europa.eu/youreurope/garantien
          </Link>
        </Flex>
      </Grid>
      <WarrantyModal isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};

export const WarrantySearchNotice: React.FC<{ compact?: boolean }> = ({ compact = false }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box
      as="section"
      aria-label={warrantyTitle}
      lang="de"
      bg="gray.800"
      borderRadius="lg"
      p={compact ? 4 : 6}
      color="white"
    >
      <Grid
        templateColumns={compact ? '72px minmax(0, 1fr)' : 'minmax(0, 1fr)'}
        gap={compact ? 4 : 5}
        alignItems="center"
      >
        <Box
          as="button"
          type="button"
          onClick={onOpen}
          aria-label="Vollständiges Original-Label anzeigen"
          aria-haspopup="dialog"
          _focusVisible={{ outline: '3px solid', outlineColor: 'brand', outlineOffset: '4px' }}
        >
          <Image
            src={warrantyImage}
            alt="Offizielles EU-Gewährleistungslabel"
            width={1697}
            height={2400}
            w="100%"
            h="auto"
            loading="lazy"
          />
        </Box>
        <Box minW={0}>
          <Heading
            as="h2"
            fontSize={compact ? 'md' : 'xl'}
            lineHeight="short"
            sx={{ hyphens: 'auto' }}
            overflowWrap="anywhere"
            mb={3}
          >
            {warrantyTitle}
          </Heading>
          {!compact && (
            <Text fontSize="sm" mb={4}>
              Informieren Sie sich über Ihre Rechte beim Fahrzeugkauf.
            </Text>
          )}
          <Button
            onClick={onOpen}
            aria-haspopup="dialog"
            variant="brandPrimary"
            size="sm"
            w={compact ? 'auto' : 'full'}
          >
            {compact ? 'Label anzeigen' : 'Original-Label anzeigen'}
          </Button>
        </Box>
      </Grid>
      <WarrantyModal isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};
